
import type { BlogPluginAppProps } from "./blog-app.props"
import { WidgetPostBlog } from "./components/WidgetPostBlog"

export default class BlogPluginApp {
    constructor({
        id,
        posts,
        width,
        height
    }: BlogPluginAppProps){
        const el = document.getElementById(id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(
            <WidgetPostBlog posts={posts} width={width} height={height} />
        )
    }
}
